import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActionItem, AppClientConfiguration, HttpService, ResponseStatus, ServiceResponse } from '@sdbn/appclient';

@Component({
  selector: 'app-action-tablet-lpr-item',
  templateUrl: './action-tablet-lpr-item.component.html',
  styleUrls: ['./action-tablet-lpr-item.component.scss']
})
export class ActionTabletLprItemComponent {

  @Input() actionItem: ActionItem;

  urls: Array<string>;

  formGroup = new FormGroup({
    numberPlate: new FormControl(null, [])
  })

  gateId: number;
  direction: string;

  messageDictionaryKey: string = null;

  constructor(
    private httpService: HttpService,
    private appClientConfiguration: AppClientConfiguration
  ) { }

  ngOnInit(): void {

    let data = JSON.parse(this.actionItem.data);
    this.gateId = data.areaGateId;
    this.direction = data.direction;

  }

  public handleNumberPlate() {

    this.messageDictionaryKey = null;

    this.httpService.postWithContext<ServiceResponse>(this.appClientConfiguration.serverURLRoot + '/tmc-common/lpr/handleNumberPlate',
      { numberPlate: this.formGroup.controls['numberPlate'].value, gateId: this.gateId, direction: this.direction }).subscribe(response => {

        if (response.status === ResponseStatus.FAILED) {

          this.messageDictionaryKey = 'tmc-common.ui.lpr-action-item.lp-handle-failed';

        } else {

          this.messageDictionaryKey = 'tmc-common.ui.lpr-action-item.lp-handled-successfully';

        }

      }, error => {
      });

  }

}
